import {konsole, _} from './util';

const dealers = {
  budmot: "Budapest&nbsp;Motors",
  leier: "Leier&nbsp;Autó&nbsp;",
  // miskmot: "Miskolc&nbsp;Motors",
  magisz: "Magisz",
  rackbudaors: "Rack&nbsp;Autó&nbsp;Budaörs",
  schneider: "Schneider&nbsp;Autóház",
  wallis: "Wallis&nbsp;Motor&nbsp;Pest"
};

const seriesCodeRxs = {
  J01: /((3|three)([_-\s]?)(ajt.*|doors?)[\s|]+Cooper E)/i,
  F66: /((3|three)([_-\s]?)(ajt.*|doors?))/i,
  F65: /((5|five)([_-\s]?)(ajt.*|doors?))/i,
  F67: /(cabrio|converti.*|kabri.*)/i,
  F54: /clubman/i,
  U25: /countryman/i,
  J05: /aceman/i
};

const numOfDealers = _.values(dealers).length;

const dealerIDs = {
  budmot: "30686_1",
  leier: "25303_1",
  magisz: "25306_1",
  // miskmot: "46865_1",
  rackbudaors: "28819_1",
  schneider: "07424_1",
  wallis: "28516_1"
};
const dealerNameIds = [
  "budmot",
  "leier",
  "magisz",
  // "miskmot",
  "rackbudaors",
  "schneider",
  "wallis"
];


const extrasIcons = {
  'sunroof': 'exterior-top-roof-and-mirrors',
  'pdc': 'dashboard-view',
  'seat_heater': 'interior-side',
  'all4': 'drive-4-wheel'
};

const sortOrders = {
  modelOrder: [
    "mini 3 ajtós",
    "mini 5 ajtós",
    "mini cabrio",
    "mini clubman",
    "mini countryman"
  ],
  typeOrder: [
    "one",
    "cooper",
    "cooper all4",
    "all4",
    "c",
    "cooper c",
    "c all4",
    "cooper c all4",
    "s",
    "cooper s",
    "s all4",
    "cooper s all4",
    "d",
    "cooper d",
    "d all4",
    "cooper d all4",
    "sd",
    "cooper sd",
    "sd all4",
    "cooper sd all4",
    "e",
    "cooper e",
    "se",
    "cooper se",
    "se all4",
    "cooper se all4",
    "john cooper works",
    "john cooper works all4"
  ],
  engineOrder: ["benzin", "dízel", "hibrid benzin", "elektromos"],
  sortByIndexedOrder: function(orderName, a, b, _getab) {
    var xA = this[orderName].indexOf(a.toLowerCase());
    var xB = this[orderName].indexOf(b.toLowerCase());
    if (xA === -1) {
      konsole.log("invalid value of xA", a);
      xA = 0;
    }
    if (xB === -1) {
      konsole.log("invalid value of xB", b);
      xB = 0;
    }
    return _getab
      ? {
        a: xA,
        b: xB
      }
      : xA - xB;
  },
  sortIndexByModel: function(a, b, _getab) {
    return sortOrders.sortByIndexedOrder("modelOrder", a, b, _getab);
  },
  sortIndexByType: function(a, b, _getab) {
    return sortOrders.sortByIndexedOrder("typeOrder", a, b, _getab);
  },
  sortIndexByEngine: function(a, b, _getab) {
    return sortOrders.sortByIndexedOrder("engineOrder", a, b, _getab);
  }
};


export {
  dealers,
  dealerIDs,
  seriesCodeRxs,
  numOfDealers,
  sortOrders,
  dealerNameIds,
  extrasIcons
};
